import { Locale, type LocalizedString } from "../../../schema/Locale.js";

export const cognitoNameToTextMapping: Record<string, LocalizedString> = {
	NotAuthorizedException: {
		[Locale.cs]: "Přístup odepřen.",
	},
	CodeMismatchException: {
		[Locale.cs]: "Zadaný kód není správný.",
	},
	UserNotFoundException: {
		[Locale.cs]: "Uživatel nenalezen.",
	},
	InvalidPasswordException: {
		[Locale.cs]: "Zadané heslo není správné.",
	},
	LimitExceededException: {
		[Locale.cs]: "Byl dosažen limit pokusů. Zkuste to prosím později.",
	},
	ExpiredCodeException: {
		[Locale.cs]: "Potvrzovací kód vypršel. Zažádejte si o nový.",
	},
	UsernameExistsException: {
		[Locale.cs]: "Uživatel s tímto e-mailem již existuje.",
	},
};

export function getExpectedCognitoError(error: unknown, locale: Locale, fallback?: string): string | undefined {
	return error instanceof Error ? cognitoNameToTextMapping[error.name]?.[locale] : fallback;
}
